"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HATTokenLockFactoriesConfig = exports.HATTokensConfig = void 0;
const wagmiChains = __importStar(require("@wagmi/chains"));
exports.HATTokensConfig = {
    test: {
        [wagmiChains.sepolia.id]: {
            address: "0xbdb34bb8665510d331facaaaa0eeae994a5b6612",
            decimals: 18,
            symbol: "HAT",
        },
    },
    prod: {
        [wagmiChains.arbitrum.id]: {
            address: "0x4D22e37Eb4d71D1acc5f4889a65936D2a44A2f15",
            decimals: 18,
            symbol: "HAT",
        },
        [wagmiChains.mainnet.id]: {
            address: "0x76c4ec0068923Da13Ee11527d6cF9b7521000049",
            decimals: 18,
            symbol: "HAT",
        },
    },
};
exports.HATTokenLockFactoriesConfig = {
    test: {
        [wagmiChains.sepolia.id]: {
            address: "0x0153A75550E32CDf9a4458301bb89b600e745EAf",
        },
    },
    prod: {
        [wagmiChains.arbitrum.id]: {
            address: "0x67aCdEb1a2b6cC7C77F9550a034aAd1f1e5A6C3C",
        },
        [wagmiChains.mainnet.id]: {
            address: "0x22262FB93e56D6109Fd6d630a31faaBF6A1a5987",
        },
    },
};
